/* Copyright (c) 2024 Xperi. All Rights Reserved. */

export const RESET_ONEPASS_LIST = 'RESET_ONEPASS_LIST';
export const SET_ONEPASS_MANAGER_IS_CARET_VISIBLE = 'SET_ONEPASS_MANAGER_IS_CARET_VISIBLE';
export const SET_ONEPASS_MANAGER_LIST = 'SET_ONEPASS_MANAGER_LIST';
export const SET_ONEPASS_MANAGER_OFFSET = 'SET_ONEPASS_MANAGER_OFFSET';
export const SET_ONEPASS_MANAGER_IS_LIST_LOADED = 'SET_ONEPASS_MANAGER_IS_LIST_LOADED';
